import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'

import { useAuth } from './context'

/**
 * Gate for authenticated routes.
 *
 * Renders a holding state while the stored token is being verified — redirecting to
 * /login during `checking` would bounce a perfectly valid session on every refresh.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth()

  if (status === 'checking') {
    return (
      <div className="page-centered">
        <p className="muted">Checking your session…</p>
      </div>
    )
  }

  if (status === 'anonymous') return <Navigate to="/login" replace />

  return <>{children}</>
}
